import React, { useState } from "react";
import { FiActivity, FiMap, FiSliders, FiCalendar, FiDroplet, FiWifi, FiBarChart2, FiAlertTriangle, FiCpu, FiFileText } from "react-icons/fi";
import { DashboardHeader } from "../../components/Shared";
import { irrigationDummyData } from "../../Data/IrrigationData";

import IrrOverviewPanel    from "./panels/IrrOverviewPanel";
import IrrFieldMapPanel    from "./panels/IrrFieldMapPanel";
import IrrZoneControlPanel from "./panels/IrrZoneControlPanel";
import IrrSchedulingPanel  from "./panels/IrrSchedulingPanel";
import IrrWaterPressurePanel from "./panels/IrrWaterPressurePanel";
import IrrLoraPanel        from "./panels/IrrLoraPanel";
import IrrAnalyticsPanel   from "./panels/IrrAnalyticsPanel";
import IrrAlertsPanel      from "./panels/IrrAlertsPanel";
import IrrAiPanel          from "./panels/IrrAiPanel";
import IrrReportsPanel     from "./panels/IrrReportsPanel";

import "./IrrigationDashboard.css";

const TABS = [
  { id: "overview",  label: "Overview",        icon: FiActivity     },
  { id: "fieldmap",  label: "Field Map",        icon: FiMap          },
  { id: "zones",     label: "Zone Control",     icon: FiSliders      },
  { id: "schedule",  label: "Scheduling",       icon: FiCalendar     },
  { id: "pressure",  label: "Water & Pressure", icon: FiDroplet      },
  { id: "lora",      label: "LoRa Network",     icon: FiWifi         },
  { id: "analytics", label: "Analytics",        icon: FiBarChart2    },
  { id: "alerts",    label: "Alerts",           icon: FiAlertTriangle},
  { id: "ai",        label: "AI Optimization",  icon: FiCpu          },
  { id: "reports",   label: "Reports",          icon: FiFileText     },
];

const IrrigationDashboard = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const d = irrigationDummyData;

  const criticalCount = d.alerts.filter(a => a.severity === "Critical" && a.status === "Open").length;

  return (
    <div className="fm-container">
      <DashboardHeader currentSolutionType="irrigation" />

      {/* Tab Bar */}
      <div className="fm-tab-bar">
        {TABS.map(tab => (
          <button
            key={tab.id}
            className={`fm-tab ${activeTab === tab.id ? "fm-tab-active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <tab.icon size={15} />
            {tab.label}
            {tab.id === "alerts" && criticalCount > 0 && (
              <span className="fm-tab-badge">{criticalCount}</span>
            )}
          </button>
        ))}
      </div>

      {/* Panel */}
      <div className="fm-panel">
        {activeTab === "overview"  && <IrrOverviewPanel    d={d} />}
        {activeTab === "fieldmap"  && <IrrFieldMapPanel    d={d} />}
        {activeTab === "zones"     && <IrrZoneControlPanel d={d} />}
        {activeTab === "schedule"  && <IrrSchedulingPanel  d={d} />}
        {activeTab === "pressure"  && <IrrWaterPressurePanel d={d} />}
        {activeTab === "lora"      && <IrrLoraPanel         d={d} />}
        {activeTab === "analytics" && <IrrAnalyticsPanel    d={d} />}
        {activeTab === "alerts"    && <IrrAlertsPanel       d={d} />}
        {activeTab === "ai"        && <IrrAiPanel           d={d} />}
        {activeTab === "reports"   && <IrrReportsPanel      d={d} />}
      </div>
    </div>
  );
};

export default IrrigationDashboard;
